export const defaultHomeSettings = {
  subtitle: "Modern Skill Education Platform",
  title: "Career-focused training with a smarter, faster, more trusted institute experience.",
  description:
    "Admissions, centre support, verification, and skill development services are organized in one polished digital front experience powered by your existing backend settings.",
  hero_primary_button_text: "Apply For Franchise",
  hero_primary_button_link: "/franchise-apply",
  hero_secondary_button_text: "Student Registration",
  hero_secondary_button_link: "/student-registration",
  hero_content_visible: true,
  banner_image: "",
  header_image_height_desktop: 140,
  header_image_height_mobile: 100,
  notices: [
    { content: "Admission Open for 2026" },
    { content: "Web Development, Digital Marketing, and Skill Training admissions are live now." },
  ],
  categories_section_title: "Most used public services in one clear modern dashboard",
  categories_section_subtitle:
    "All links stay connected to your current pages and backend flow, only the presentation is upgraded.",
  categories: [
    { title: "Franchise", helper: "Apply and access centre panel", icon: "bi-buildings-fill", path: "/franchise-apply" },
    { title: "Student", helper: "Admissions and student services", icon: "bi-mortarboard-fill", path: "/student-registration" },
    { title: "Result", helper: "Check academic result flow", icon: "bi-bar-chart-fill", path: "/result-verification" },
    { title: "Certificate", helper: "Verification and authenticity", icon: "bi-patch-check-fill", path: "/student-verification" },
    { title: "Download", helper: "Important files and resources", icon: "bi-cloud-arrow-down-fill", path: "/downloadcenter" },
    { title: "Gallery", helper: "Institute activity snapshots", icon: "bi-images", path: "/gallery" },
  ],
  counters_section_title: "Everything Is NIDCS",
  counters: [
    { label: "Courses", value: 29 },
    { label: "Students", value: 7 },
    { label: "Branches", value: 5 },
  ],
  features_section_title: "A cleaner and stronger digital experience for learners, centres, and administrators",
  features_section_subtitle:
    "The interface follows the master admin visual language so your public site and backend feel like one connected product.",
  features: [
    { title: "Expert Trainers", desc: "Structured learning from experienced mentors with practical skill focus.", icon: "bi-people-fill" },
    { title: "Career Support", desc: "Program flow designed to support employability and centre growth together.", icon: "bi-briefcase-fill" },
    { title: "Trusted Certification", desc: "Recognition-ready learning path with verification-friendly institute workflow.", icon: "bi-award-fill" },
  ],
  affiliations_section_title: "Our Affiliation",
  affiliations: [],
};

const normalizeList = (items, fallback) => {
  if (!Array.isArray(items) || items.length === 0) return fallback;
  return items.filter(Boolean);
};

export function normalizeHomeSettings(input) {
  const settings = input?.settings || input || {};

  return {
    ...defaultHomeSettings,
    ...settings,
    hero_content_visible: settings?.hero_content_visible !== false && settings?.hero_content_visible !== 0 && settings?.hero_content_visible !== "0",
    header_image_height_desktop: Number(settings?.header_image_height_desktop || defaultHomeSettings.header_image_height_desktop),
    header_image_height_mobile: Number(settings?.header_image_height_mobile || defaultHomeSettings.header_image_height_mobile),
    notices: normalizeList(settings?.notices, defaultHomeSettings.notices),
    categories: normalizeList(settings?.categories, defaultHomeSettings.categories),
    counters: normalizeList(settings?.counters, defaultHomeSettings.counters),
    features: normalizeList(settings?.features, defaultHomeSettings.features),
    affiliations: normalizeList(settings?.affiliations, defaultHomeSettings.affiliations),
  };
}
